<template>
    <div
        style="display:flex;flex: 1;"
    >
        <nav-drawer-mobile
            v-if="this.$vuetify.breakpoint.xsOnly"
            @toggle-navdrawer="toggleNavdrawer"
        />
        <nav-drawer
            v-else
            :mini="navbarMini"
        />
        <app-bar
            :hamburger-icon="hamburger"
            @toggle-navbar="toggleNavBar"
            @toggle-navdrawer="toggleNavdrawer"
        />
        <v-main>
            <router-view />
        </v-main>
    </div>
</template>

<script>
import NavDrawer from '@/components/NavDrawer.vue';
import NavDrawerMobile from '@/components/NavDrawerMobile.vue';
import AppBar from '@/components/AppBar.vue';

export default {
    name: 'AppLayout',
    components: {
        NavDrawer,
        NavDrawerMobile,
        AppBar,
    },
    computed: {
        navbarMini() {
            return this.$store.getters.navbarMini;
        },
        navdrawerOpen() {
            return this.$store.getters.navdrawerOpen;
        },
        hamburger: function () {
            return this.navbarMini ? 'menu' : 'menu_open';
        },
    },
    methods: {
        toggleNavBar() {
            // on XS, the nav bar button only opens, so if we are on XS we can force false
            // const setValue = this.$vuetify.breakpoint.xsOnly ? false : !this.navbarMini;
            
            this.$store.commit('SET_NAVBAR_MINI', !this.navbarMini);
        },
        toggleNavdrawer() {
            this.$store.commit('SET_NAVDRAWER_OPEN', !this.navdrawerOpen);
        },
    },
};
</script>